import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { Constants } from '@app/shared-module/constants';
import { GlobalResponse } from '@app/shared-module/models';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-payment',
  templateUrl: './update-payment.component.html',
  styleUrls: ['./update-payment.component.scss']
})
export class UpdatePaymentComponent implements OnInit {
  public headerTitle: string;
  paymentDate: any;
  itemId: string;
  paymentReferenceNo: string;
  paidAmount = 0;
  @BlockUI() blockUI: NgBlockUI;

  current_date: any = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    showClearDateBtn: true,
    disableSince: { year: this.current_date.getFullYear(), month: this.current_date.getMonth() + 1, day: this.current_date.getDate() + 1 }
  };

  constructor(
    public dialogRef: MatDialogRef<UpdatePaymentComponent>,
    private service: AdminService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
  }

  onPaymentDateChanged = (event: IMyDateModel) => {
    this.paymentDate = event.formatted;
  }

  updatePayment() {
    if (this.paymentReferenceNo && this.paymentReferenceNo.length > 0 &&
      this.paidAmount && this.paidAmount > 0 && this.paymentDate && this.paymentDate.formatted) {
      const payload = {
        paymentDate: this.paymentDate.formatted,
        paymentReferenceNo: this.paymentReferenceNo,
        paidAmount: this.paidAmount
      };
      this.blockUI.start();
      this.service.updateClinicPayment(this.itemId, payload).subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.dialogRef.close(res.result);
        }
      });
    } else {
      this.toastr.error('Please enter all the fields.');
    }

  }

  updateRole() {
    // if (this.st && this.name.length > 0) {
    // const newName = this.name;
    // this.admServc.uploadInternalUserRole(this.userID, this.role).subscribe((res: GlobalResponse) => {
    //   if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
    //     this.dialogRef.close(res.result);
    //   }
    // });
    // } else {
    //   this.toastr.error('Please enter name');
    // }
  }
}
